// TIRAS CRM V2 — React Entry Point
import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/global.css';   // Global mobile layout fixes — must be first
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
